import { TextInput } from 'modules/v2/forms/TextInput';
import { MenuInput } from './MenuInput';
import { InputContainer } from './styled';
export function MenuTextInput(props) {
    return (<MenuInput render={<InputContainer>
          <TextInput {...props} stretch/>
        </InputContainer>}/>);
}
